import React, { useEffect, useRef, createElement } from 'react';
interface IntroAnimationProps {
  onComplete: () => void;
}
export const IntroAnimation: React.FC<IntroAnimationProps> = ({
  onComplete
}) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const rainRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const createRaindrops = () => {
      if (!rainRef.current) return;
      rainRef.current.innerHTML = '';
      const numberOfDrops = 100; // Increased number of drops
      for (let i = 0; i < numberOfDrops; i++) {
        const drop = document.createElement('div');
        drop.className = 'intro-raindrop';
        // Randomize drop properties for more natural effect
        const size = Math.random() * 1.5 + 0.5;
        const posX = Math.random() * 100;
        const delay = Math.random() * 2;
        const duration = Math.random() * 1 + 1.5;
        const opacity = Math.random() * 0.3 + 0.2; // Increased opacity
        drop.style.cssText = `
          width: ${size}px;
          left: ${posX}%;
          animation-delay: ${delay}s;
          animation-duration: ${duration}s;
          opacity: ${opacity};
        `;
        rainRef.current.appendChild(drop);
      }
    };
    createRaindrops();
    const interval = setInterval(createRaindrops, 3000);
    const timer = setTimeout(() => {
      if (containerRef.current) {
        containerRef.current.style.opacity = '0';
      }
      setTimeout(onComplete, 1000);
    }, 3500); // Increased duration
    return () => {
      clearTimeout(timer);
      clearInterval(interval);
    };
  }, [onComplete]);
  return <div ref={containerRef} className="fixed inset-0 z-[100] bg-black flex items-center justify-center transition-opacity duration-1000" data-id="element-246">
      <div ref={rainRef} className="absolute inset-0 overflow-hidden pointer-events-none" data-id="element-247"></div>
      <div className="relative" data-id="element-248">
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/jJy59TMDp1yB3h9h9tuSsL/LOGO_BLUEsmall.png" alt="Blue Rain Productions Logo Animatie" className="w-48 md:w-64 opacity-0 animate-[fadeIn_1.5s_ease-out_forwards] relative z-10" data-id="element-249" />
        {/* Enhanced glow effects */}
        <div className="absolute -inset-4 bg-blue-500/20 blur-xl animate-pulse-slow rounded-full" data-id="element-250"></div>
        <div className="absolute -inset-8 bg-blue-600/10 blur-2xl animate-pulse-slow rounded-full" data-id="element-251"></div>
        <div className="absolute -inset-12 bg-blue-700/5 blur-3xl animate-pulse-slow rounded-full" data-id="element-252"></div>
      </div>
      <style jsx data-id="element-253">{`
        @keyframes intro-raindrop {
          0% {
            transform: translateY(-100vh) translateX(-10px);
            opacity: 0;
          }
          10% {
            opacity: var(--opacity);
          }
          90% {
            opacity: var(--opacity);
          }
          100% {
            transform: translateY(100vh) translateX(10px);
            opacity: 0;
          }
        }
        .intro-raindrop {
          position: absolute;
          top: -20px;
          background: linear-gradient(
            to bottom,
            rgba(59, 130, 246, 0.01),
            rgba(59, 130, 246, 0.6)
          );
          height: 20px;
          border-radius: 0 0 2px 2px;
          filter: drop-shadow(0 0 5px rgba(59, 130, 246, 0.5));
          animation: intro-raindrop linear infinite;
          z-index: 5;
          --opacity: attr(style.opacity);
        }
        @media (max-width: 768px) {
          .intro-raindrop {
            height: 16px;
          }
        }
      `}</style>
    </div>;
};